import { useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { Formik } from 'formik';
import Button from '../components/Button';
import Loader from '../components/Loader';
import { Field, FieldLabel, FieldSelect } from '../components/Field';
import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { SPACE_MEMBERS } from '../utilities/queries';
import { UPDATE_TOPIC_ASSIGNEE } from '../utilities/mutations';

const AssignTopicModal = ({ topicId, assignee, onClose }) => {
  const params = useParams();
  const toast = useToast();
  const { loading, data } = useQuery(SPACE_MEMBERS, {
    variables: { slug: params.s },
  });
  const [updateTopicAssignee] = useMutation(UPDATE_TOPIC_ASSIGNEE);

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()}>
      {loading ? (
        <ModalPart>
          <Loader />
        </ModalPart>
      ) : (
        <>
          <ModalExit />
          <ModalName>Assign topic</ModalName>
          <Formik
            initialValues={{
              assigneeId: assignee?.id,
            }}
            onSubmit={async (values) => {
              try {
                const data = await updateTopicAssignee({
                  variables: {
                    id: topicId,
                    assigneeId: values.assigneeId,
                  },
                });

                toast({
                  children: `${data.data.updateTopicAssignee.assignee.name} was assigned`,
                });
              } catch (error) {
                toast({ children: error.message });

                return;
              }

              close();
            }}
          >
            {({ values, handleSubmit, isSubmitting, setFieldValue }) => (
              <form onSubmit={handleSubmit}>
                <ModalPart>
                  <Field>
                    <FieldLabel>Assignee</FieldLabel>
                    <FieldSelect
                      onChange={(e) =>
                        setFieldValue('assigneeId', e.target.value)
                      }
                      value={values.assigneeId}
                      data-autofocus
                    >
                      <option disabled selected value>
                        Choose an assignee
                      </option>
                      {data.space.members.map((user) => (
                        <option value={user.user.id}>{user.user.name}</option>
                      ))}
                    </FieldSelect>
                  </Field>
                </ModalPart>
                <ModalPart>
                  {assignee?.id && (
                    <Button
                      type="button"
                      onClick={async () => {
                        try {
                          await updateTopicAssignee({
                            variables: {
                              id: topicId,
                              assigneeId: null,
                            },
                          });
                          toast({ children: 'Unassigned' });
                        } catch (error) {
                          toast({ children: error.message });

                          return;
                        }

                        close();
                      }}
                      isExtended
                    >
                      Unassign
                    </Button>
                  )}
                  <Button
                    type="submit"
                    disabled={
                      (values.assigneeId === 'undefined' &&
                        values.assigneeId !== 'undefined') ||
                      assignee?.id === values.assigneeId ||
                      isSubmitting
                    }
                    isPrimary
                    isExtended
                  >
                    Assign
                  </Button>
                </ModalPart>
              </form>
            )}
          </Formik>
        </>
      )}
    </Modal>
  );
};

export default AssignTopicModal;
